var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect0, _rect1, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32, _rect33, _rect34, _rect35, _rect36, _rect37, _rect38, _rect39, _rect40, _rect41, _rect42, _rect43, _rect44, _rect45, _rect46, _rect47, _rect48, _rect49, _rect50, _rect51, _rect52, _rect53, _rect54, _rect55, _rect56, _rect57, _rect58, _rect59, _rect60, _rect61, _rect62, _rect63, _rect64, _rect65, _rect66, _rect67, _rect68, _rect69, _rect70, _rect71, _rect72, _rect73, _rect74, _rect75, _rect76, _rect77, _rect78, _rect79, _rect80, _rect81, _rect82, _rect83, _rect84, _rect85, _rect86, _rect87, _rect88, _rect89, _rect90, _rect91, _rect92, _rect93, _rect94, _rect95, _rect96, _rect97, _rect98, _rect99, _rect100, _rect101, _rect102, _rect103, _rect104, _rect105, _rect106, _rect107, _rect108;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "35 20 250 200",
    xmlns: "http://www.w3.org/2000/svg",
    shapeRendering: "crispEdges",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 10,
    x: 110,
    y: 30,
    fill: "#262626"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 140,
    height: 10,
    x: 90,
    y: 40,
    fill: "#262626"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 10,
    x: 30,
    y: 50,
    fill: "#262626"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 10,
    x: 130,
    y: 50,
    fill: "#ffffff"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 130,
    height: 10,
    x: 160,
    y: 50,
    fill: "#262626"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    x: 30,
    y: 60,
    fill: "#262626"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 10,
    x: 40,
    y: 60,
    fill: "#ffffff"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 10,
    x: 80,
    y: 60,
    fill: "#262626"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    x: 160,
    y: 60,
    fill: "#ffffff"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 10,
    x: 170,
    y: 60,
    fill: "#262626"
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 10,
    x: 190,
    y: 60,
    fill: "#ffffff"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 10,
    x: 210,
    y: 60,
    fill: "#262626"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 10,
    x: 240,
    y: 60,
    fill: "#ffffff"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    x: 280,
    y: 60,
    fill: "#262626"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    x: 30,
    y: 70,
    fill: "#262626"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 10,
    x: 40,
    y: 70,
    fill: "#ffffff"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 10,
    x: 70,
    y: 70,
    fill: "#262626"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 10,
    x: 100,
    y: 70,
    fill: "#ffffff"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 10,
    x: 120,
    y: 70,
    fill: "#262626"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    x: 160,
    y: 70,
    fill: "#ffffff"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 10,
    x: 170,
    y: 70,
    fill: "#262626"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 10,
    x: 210,
    y: 70,
    fill: "#ffffff"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 10,
    x: 230,
    y: 70,
    fill: "#262626"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 10,
    x: 260,
    y: 70,
    fill: "#ffffff"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    x: 280,
    y: 70,
    fill: "#262626"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    x: 40,
    y: 80,
    fill: "#262626"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    x: 50,
    y: 80,
    fill: "#ffffff"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    width: 160,
    height: 10,
    x: 60,
    y: 80,
    fill: "#262626"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    x: 220,
    y: 80,
    fill: "#ffffff"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 10,
    x: 230,
    y: 80,
    fill: "#262626"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    x: 260,
    y: 80,
    fill: "#ffffff"
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    x: 270,
    y: 80,
    fill: "#262626"
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    width: 240,
    height: 10,
    x: 40,
    y: 90,
    fill: "#262626"
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 10,
    x: 50,
    y: 100,
    fill: "#262626"
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    x: 90,
    y: 100,
    fill: "#ffffff"
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    width: 170,
    height: 10,
    x: 100,
    y: 100,
    fill: "#262626"
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 10,
    x: 60,
    y: 110,
    fill: "#262626"
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 10,
    x: 80,
    y: 110,
    fill: "#ffffff"
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    width: 160,
    height: 10,
    x: 100,
    y: 110,
    fill: "#262626"
  })), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    x: 60,
    y: 120,
    fill: "#262626"
  })), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 10,
    x: 70,
    y: 120,
    fill: "#ffffff"
  })), _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    width: 170,
    height: 10,
    x: 90,
    y: 120,
    fill: "#262626"
  })), _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 10,
    x: 60,
    y: 130,
    fill: "#262626"
  })), _rect42 || (_rect42 = /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    x: 80,
    y: 130,
    fill: "#ffffff"
  })), _rect43 || (_rect43 = /*#__PURE__*/React.createElement("rect", {
    width: 170,
    height: 10,
    x: 90,
    y: 130,
    fill: "#262626"
  })), _rect44 || (_rect44 = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 10,
    x: 60,
    y: 140,
    fill: "#262626"
  })), _rect45 || (_rect45 = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 10,
    x: 80,
    y: 140,
    fill: "#ffffff"
  })), _rect46 || (_rect46 = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 10,
    x: 100,
    y: 140,
    fill: "#262626"
  })), _rect47 || (_rect47 = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 10,
    x: 120,
    y: 140,
    fill: "#ffffff"
  })), _rect48 || (_rect48 = /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 10,
    x: 140,
    y: 140,
    fill: "#262626"
  })), _rect49 || (_rect49 = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 10,
    x: 70,
    y: 150,
    fill: "#262626"
  })), _rect50 || (_rect50 = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 10,
    x: 90,
    y: 150,
    fill: "#ffffff"
  })), _rect51 || (_rect51 = /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 10,
    x: 130,
    y: 150,
    fill: "#262626"
  })), _rect52 || (_rect52 = /*#__PURE__*/React.createElement("rect", {
    width: 180,
    height: 10,
    x: 70,
    y: 160,
    fill: "#262626"
  })), _rect53 || (_rect53 = /*#__PURE__*/React.createElement("rect", {
    width: 160,
    height: 10,
    x: 80,
    y: 170,
    fill: "#262626"
  })), _rect54 || (_rect54 = /*#__PURE__*/React.createElement("rect", {
    width: 140,
    height: 10,
    x: 90,
    y: 180,
    fill: "#262626"
  })), _rect55 || (_rect55 = /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 10,
    x: 100,
    y: 190,
    fill: "#262626"
  })), _rect56 || (_rect56 = /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 10,
    x: 120,
    y: 200,
    fill: "#262626"
  })), _rect57 || (_rect57 = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 10,
    x: 150,
    y: 160,
    fill: "#262527"
  })), _rect58 || (_rect58 = /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    x: 140,
    y: 170,
    fill: "#262527"
  })), _rect59 || (_rect59 = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 10,
    x: 120,
    y: 160,
    fill: "#000000"
  })), _rect60 || (_rect60 = /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    x: 140,
    y: 160,
    fill: "#090609"
  })), _rect61 || (_rect61 = /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 10,
    x: 150,
    y: 160,
    fill: "#000000"
  })), _rect62 || (_rect62 = /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    x: 120,
    y: 170,
    fill: "#000000"
  })), _rect63 || (_rect63 = /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 10,
    x: 130,
    y: 170,
    fill: "#ffffff"
  })), _rect64 || (_rect64 = /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    x: 190,
    y: 170,
    fill: "#000000"
  })), _rect65 || (_rect65 = /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    x: 110,
    y: 180,
    fill: "#000000"
  })), _rect66 || (_rect66 = /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    x: 120,
    y: 180,
    fill: "#ffffff"
  })), _rect67 || (_rect67 = /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    x: 130,
    y: 180,
    fill: "#d8545c"
  })), _rect68 || (_rect68 = /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    x: 140,
    y: 180,
    fill: "#d74565"
  })), _rect69 || (_rect69 = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 10,
    x: 150,
    y: 180,
    fill: "#d8545c"
  })), _rect70 || (_rect70 = /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    x: 190,
    y: 180,
    fill: "#ffffff"
  })), _rect71 || (_rect71 = /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    x: 200,
    y: 180,
    fill: "#000000"
  })), _rect72 || (_rect72 = /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    x: 100,
    y: 190,
    fill: "#000000"
  })), _rect73 || (_rect73 = /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    x: 110,
    y: 190,
    fill: "#ffffff"
  })), _rect74 || (_rect74 = /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 10,
    x: 120,
    y: 190,
    fill: "#d74565"
  })), _rect75 || (_rect75 = /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    x: 200,
    y: 190,
    fill: "#ffffff"
  })), _rect76 || (_rect76 = /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    x: 210,
    y: 190,
    fill: "#000000"
  })), _rect77 || (_rect77 = /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    x: 100,
    y: 200,
    fill: "#000000"
  })), _rect78 || (_rect78 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 10,
    x: 110,
    y: 200,
    fill: "#ba2735"
  })), _rect79 || (_rect79 = /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    x: 210,
    y: 200,
    fill: "#000000"
  })), _rect80 || (_rect80 = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 10,
    x: 100,
    y: 210,
    fill: "#000000"
  })), _rect81 || (_rect81 = /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    x: 140,
    y: 210,
    fill: "#090609"
  })), _rect82 || (_rect82 = /*#__PURE__*/React.createElement("rect", {
    width: 70,
    height: 10,
    x: 150,
    y: 210,
    fill: "#000000"
  })), _rect83 || (_rect83 = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 10,
    x: 100,
    y: 100,
    fill: "#000000"
  })), _rect84 || (_rect84 = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 10,
    x: 190,
    y: 100,
    fill: "#000000"
  })), _rect85 || (_rect85 = /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    x: 90,
    y: 110,
    fill: "#000000"
  })), _rect86 || (_rect86 = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 10,
    x: 100,
    y: 110,
    fill: "#ffffff"
  })), _rect87 || (_rect87 = /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    x: 130,
    y: 110,
    fill: "#000000"
  })), _rect88 || (_rect88 = /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    x: 180,
    y: 110,
    fill: "#000000"
  })), _rect89 || (_rect89 = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 10,
    x: 190,
    y: 110,
    fill: "#ffffff"
  })), _rect90 || (_rect90 = /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    x: 220,
    y: 110,
    fill: "#000000"
  })), _rect91 || (_rect91 = /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    x: 90,
    y: 120,
    fill: "#000000"
  })), _rect92 || (_rect92 = /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    x: 100,
    y: 120,
    fill: "#ffffff"
  })), _rect93 || (_rect93 = /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    x: 110,
    y: 120,
    fill: "#000000"
  })), _rect94 || (_rect94 = /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    x: 120,
    y: 120,
    fill: "#ffffff"
  })), _rect95 || (_rect95 = /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    x: 130,
    y: 120,
    fill: "#000000"
  })), _rect96 || (_rect96 = /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    x: 180,
    y: 120,
    fill: "#000000"
  })), _rect97 || (_rect97 = /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    x: 190,
    y: 120,
    fill: "#ffffff"
  })), _rect98 || (_rect98 = /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    x: 200,
    y: 120,
    fill: "#000000"
  })), _rect99 || (_rect99 = /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    x: 210,
    y: 120,
    fill: "#ffffff"
  })), _rect100 || (_rect100 = /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    x: 220,
    y: 120,
    fill: "#000000"
  })), _rect101 || (_rect101 = /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    x: 90,
    y: 130,
    fill: "#000000"
  })), _rect102 || (_rect102 = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 10,
    x: 100,
    y: 130,
    fill: "#ffffff"
  })), _rect103 || (_rect103 = /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    x: 130,
    y: 130,
    fill: "#000000"
  })), _rect104 || (_rect104 = /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    x: 180,
    y: 130,
    fill: "#000000"
  })), _rect105 || (_rect105 = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 10,
    x: 190,
    y: 130,
    fill: "#ffffff"
  })), _rect106 || (_rect106 = /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    x: 220,
    y: 130,
    fill: "#000000"
  })), _rect107 || (_rect107 = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 10,
    x: 100,
    y: 140,
    fill: "#000000"
  })), _rect108 || (_rect108 = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 10,
    x: 190,
    y: 140,
    fill: "#000000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.0dad976d957f193ddf7e5f310e63a673.svg";
export { ForwardRef as ReactComponent };